import React, {
  useEffect,
  useState,
  useImperativeHandle,
  useRef,
  useCallback
} from 'react';
import { isBrowser, createPortal } from '@helpers';
import styles from './Media.module.scss';
import ResizeObserver from 'resize-observer-polyfill';
import { RemoveScroll } from 'react-remove-scroll';
import FocusLock from 'react-focus-lock';
import classNames from 'classnames';

const VideoModal = React.forwardRef((props, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  const [media, setMedia] = useState({
    src: null,
    previewRef: null,
    playerClassName: null,
    playerStyle: null
  });

  const [Player, setPlayer] = useState(null);
  const playTimer = useRef();

  useEffect(() => {
    import('react-player').then(Player => setPlayer(() => Player.default));
  }, []);

  console.log(Player);

  useImperativeHandle(ref, () => ({
    test: () => console.log('TEST HANDLE HERE')
  }));

  const hasInitialized = useRef(false);
  const wrapper = useRef();
  const modal = useRef();
  const bg = useRef();
  const [bgTransform, setBgTransform] = useState(null);

  const isOpenRef = useRef(false);

  useEffect(() => {
    isOpenRef.current = isOpen;
  }, [isOpen]);

  const toggleModal = useCallback(() => {
    if (isOpen && modal.current && media.previewRef?.current) {
      document.activeElement?.blur();
      const preview = media.previewRef.current;
      const modalRect = modal.current.getBoundingClientRect();
      clearTimeout(playTimer.current);

      if (modalRect.height === 0) {
        hasInitialized.current = true;
        return;
      }

      const previewRect = preview.current.getBoundingClientRect();
      const x = previewRect.left - modalRect.left;
      const y = previewRect.top - modalRect.top;
      const scaleX = previewRect.width / modalRect.width;
      const scaleY = previewRect.height / modalRect.height;

      setBgTransform(
        `translate3d(${x}px, ${y}px, 0) scale(${scaleX}, ${scaleY})`
      );

      if (!hasInitialized.current) {
        setIsPlaying(isOpenRef.current);
      } else {
        playTimer.current = setTimeout(() => {
          if (isOpenRef.current) {
            setIsPlaying(true);
          }
        }, 200);
      }

      hasInitialized.current = true;
    } else {
      clearTimeout(playTimer.current);
      setIsPlaying(false);
      setBgTransform(null);
    }
  }, [isOpen, playTimer, media, setIsPlaying]);

  useEffect(() => {
    const el = modal.current;
    let observer = null;

    if (!hasInitialized.current && el) {
      observer = new ResizeObserver(toggleModal);
      observer.observe(el);
    } else {
      toggleModal();
    }

    return () => {
      if (el && observer) {
        observer.unobserve(el);
      }
    };
  }, [toggleModal]);

  return createPortal(
    <RemoveScroll enabled={isOpen}>
      <FocusLock disabled={!isOpen}>
        <div
          ref={wrapper}
          className={classNames(styles.modalWrapper, {
            [styles.open]: isOpen && bgTransform
          })}
        >
          <div
            className={styles.modal}
            ref={modal}
          >
            <div className={styles.modalPlayer}>
              {((!hasInitialized.current && !isOpen) || isOpen) && (
                <Player
                  url={media.src}
                  className={classNames(
                    styles.player,
                    media.playerClassName
                  )}
                  playing={isOpen && isPlaying}
                  style={media.playerStyle}
                  width="100%"
                  height="100%"
                  config={{
                    youtube: {
                      playerVars: {
                        origin: isBrowser()
                          ? window.location.origin
                          : null,
                        rel: 0
                      }
                    }
                  }}
                  controls
                  // onDuration={duration => {
                  //   setDuration(duration);
                  //   setIsLoadingDuration(false);
                  // }}
                  // onError={() => setIsLoadingDuration(false)}
                  // {..._playerProps}
                />
              )}
            </div>
            <div
              ref={bg}
              className={styles.bg}
              style={{ transform: bgTransform }}
            />
          </div>
          <div
            className={styles.wrapperBg}
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              setIsPlaying(false);
              setIsOpen(false);
            }}
          />
        </div>
      </FocusLock>
    </RemoveScroll>
  );
});

export default React.memo(VideoModal);
